import React, { PureComponent } from 'react'
import MenuItem from 'material-ui/MenuItem'
import DropDownMenu from 'material-ui/DropDownMenu'
import { Toolbar, ToolbarGroup } from 'material-ui/Toolbar'
import { HashLink as Link } from 'react-router-hash-link'
import { toolbarStyles } from '../styles/theme'

const styles = {
  toolbar: {
    position: 'fixed',
    top: 50,
    width: '100%',
    marginLeft: 0,
    zIndex: 99,
  },
}

export default class InfoTopMenu extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      value: 1,
    }
  }

  handleChange = (event, index, value) => this.setState({ value })

  render() {
    return (
      <Toolbar style={styles.toolbar}>
        <ToolbarGroup firstChild={true}>
          <DropDownMenu
            value={this.state.value}
            onChange={this.handleChange}
            iconStyle={toolbarStyles.iconStyle}>
            <MenuItem
              value={1}
              primaryText="Perchè Swapick"
              containerElement={<Link to="/come-funziona#perche-swapick" />}
            />
            <MenuItem
              value={2}
              primaryText="Come funziona"
              containerElement={<Link to="/come-funziona#come-fare" />}
            />
            <MenuItem
              value={3}
              primaryText="Guida alla sicurezza"
              containerElement={<Link to="/come-funziona#guida-sicurezza" />}
            />
            <MenuItem
              value={4}
              primaryText="Spedizione degli oggetti"
              containerElement={<Link to="/come-funziona#spedizione-oggetti" />}
            />
            <MenuItem
              value={5}
              primaryText="Domade frequenti"
              containerElement={<Link to="/come-funziona#faq" />}
            />
            <MenuItem
              value={6}
              primaryText="Servizi Aggiuntivi"
              containerElement={<Link to="/come-funziona#servizi-aggiuntivi" />}
            />
            <MenuItem
              value={7}
              primaryText="Termini e condizioni"
              containerElement={<Link to="/come-funziona#termini-condizioni" />}
            />
            <MenuItem
              value={8}
              primaryText="Privacy Policy"
              containerElement={<Link to="/come-funziona#privacy-policy" />}
            />
            <MenuItem
              value={9}
              primaryText="Cookie Policy"
              containerElement={<Link to="/come-funziona#cookie-policy" />}
            />
          </DropDownMenu>
        </ToolbarGroup>
      </Toolbar>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/InfoTopMenu.js